import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const ValidationBlockStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${colors.red[100]};
  padding: 2rem 3rem;
  border-radius: 10px;
  text-align: left;
  margin: 0 auto;
`;

export const ValidationTitleWrapperStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding-bottom: 1rem;
  border-bottom: 0.1rem solid ${colors.red[300]};
`;

export const ValidationTitleStyled = styled.b`
  ${typography.bold[18]};
  color: ${colors.red[600]};
  text-align: center;
`;

export const ValidationListStyled = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.5rem;
  margin-bottom: 0;
  ${typography.regular[16]};
  padding-left: 2rem;
  text-align: left;
  color: ${colors.neutral[900]};

  &:has(> li:only-child) {
    list-style: none;
    padding-left: 0;
  }
`;
